import React from "react";
import File from "./File";

const Files = ({
  files,
  showCopyLink,
  onSelectFile,
  onSelectConfirmed,
  selectedFile
}) => {
  return (
    <div>
      <div className="grid grid-cols-1 row-gap-2 col-gap-2 sm:grid-cols-9 p-1">
        {files.map(file => (
          <File
            key={file.id}
            file={file}
            showCopyLink={showCopyLink}
            onSelect={onSelectFile}
            onSelectConfirmed={onSelectConfirmed}
            isSelected={
              selectedFile && selectedFile.id && selectedFile.id == file.id
                ? true
                : false
            }
          />
        ))}
      </div>
    </div>
  );
}; 

export default Files;
